import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {InternaNovedadesComponent} from './shared/interna-novedades/interna-novedades.component';
import {HomeComponent} from './shared/home/home.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: ':id', component: HomeComponent },
  { path: 'novedades/:slug', component: InternaNovedadesComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
